import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth, isTTC } from '../hooks/useAuth';
import { useCart } from '../hooks/useCart';
import toast from 'react-hot-toast';
import { StatusBadge } from '../components/StatusBadge';
import api from '../utils/api';
import { format } from 'date-fns';

const STATUSES = ['','submitted','approved','in_production','shipped','delivered','closed','cancelled'];

export default function OrdersPage() {
  const { user } = useAuth();
  const { addItem } = useCart();
  const nav2 = (path) => { window.location.href = path; };

  const reorder = async (orderId) => {
    try {
      const r = await api.get(`/api/orders/${orderId}/reorder-data`);
      const items = r.data.items || [];
      const skipped = items.filter(i => !i.active).length;
      let added = 0;
      for (const item of items) {
        if (!item.active) continue;
        addItem({ id: item.product_id, name: item.product_name, sku: item.sku }, item.quantity, item.attributes, item.price_per_m);
        added++;
      }
      if (skipped) toast.error(`${skipped} item(s) no longer available were skipped.`);
      if (added) { toast.success(`${added} item${added > 1 ? 's' : ''} added to cart`); window.location.href = '/cart'; }
      else if (!skipped) toast.error('Nothing to reorder.');
    } catch (e) { toast.error('Could not load that order to reorder.'); }
  };
  const [orders, setOrders] = useState([]);
  const [total, setTotal] = useState(0);
  const [page, setPage] = useState(1);
  const [pages, setPages] = useState(1);
  const [status, setStatus] = useState('');
  const [loading, setLoading] = useState(true);

  const load = (p = 1, s = status) => {
    setLoading(true);
    const params = new URLSearchParams({ page: p, limit: 25 });
    if (s) params.set('status', s);
    api.get(`/api/orders?${params}`).then(r => {
      setOrders(r.data.orders);
      setTotal(r.data.total);
      setPage(r.data.page);
      setPages(r.data.pages);
      setLoading(false);
    }).catch(() => setLoading(false));
  };

  useEffect(() => { load(1, status); }, [status]);

  return (
    <>
      <div className="topbar">
        <h2>Orders</h2>
        <Link to="/catalog" className="btn btn-gold btn-sm">+ New Order</Link>
      </div>
      <div className="page">
        <div className="filter-bar">
          <select className="form-select" value={status} onChange={e => setStatus(e.target.value)} style={{width:180}}>
            <option value="">All Statuses</option>
            {STATUSES.filter(Boolean).map(s => (
              <option key={s} value={s}>{s.replace(/_/g,' ').replace(/\b\w/g,c=>c.toUpperCase())}</option>
            ))}
          </select>
          <span className="text-muted text-sm">{total} orders</span>
        </div>

        <div className="card" style={{padding:0}}>
          {loading ? (
            <div className="loading">Loading…</div>
          ) : !orders.length ? (
            <div className="empty-state">No orders found.</div>
          ) : (
            <div className="table-wrap">
              <table>
                <thead>
                  <tr>
                    <th>Order #</th>
                    {isTTC(user) && <th>Customer</th>}
                    <th>Status</th>
                    <th>{!isTTC(user) && orders[0]?.po_field_label ? orders[0].po_field_label : 'PO #'}</th>
                    <th>Total</th>
                    <th>Placed By</th>
                    <th>Date</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  {orders.map(o => (
                    <tr key={o.id}>
                      <td><strong>{o.order_number}</strong></td>
                      {isTTC(user) && <td>{o.customer_name}</td>}
                      <td><StatusBadge status={o.status} /></td>
                      <td className="text-muted">{o.po_number || '—'}</td>
                      <td>{o.total_amount ? `$${Number(o.total_amount).toLocaleString('en-US',{minimumFractionDigits:2})}` : '—'}</td>
                      <td className="text-sm">{o.first_name} {o.last_name}</td>
                      <td className="text-muted text-sm">{format(new Date(o.created_at),'MM/dd/yyyy')}</td>
                      <td>
                        <Link to={`/orders/${o.id}`} className="btn btn-ghost btn-sm">View</Link>
                        <button className="btn btn-ghost btn-sm" onClick={() => reorder(o.id)}>Reorder</button>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>

        {pages > 1 && (
          <div style={{display:'flex', gap:8, marginTop:16, justifyContent:'center'}}>
            <button className="btn btn-secondary btn-sm" disabled={page===1} onClick={() => load(page-1)}>← Prev</button>
            <span className="text-muted text-sm" style={{display:'flex',alignItems:'center'}}>Page {page} of {pages}</span>
            <button className="btn btn-secondary btn-sm" disabled={page===pages} onClick={() => load(page+1)}>Next →</button>
          </div>
        )}
      </div>
    </>
  );
}
